let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8uqy1")).then(() => parcelRequire('a18b2'));